// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".breadcrumbs[data-v-74e40918]{list-style:none;-webkit-padding-start:0;padding-inline-start:0;margin:0 0 24px}.breadcrumbs__item[data-v-74e40918]{text-transform:capitalize}.breadcrumbs__delimiter[data-v-74e40918]{height:4px;width:1px;background-color:#657182;margin:0 12px}.breadcrumbs li[data-v-74e40918]{display:inline-flex;align-items:center}.breadcrumbs li a[data-v-74e40918],.breadcrumbs li span[data-v-74e40918]{color:#657182}", ""]);
// Exports
module.exports = exports;
